import React, { useEffect, useState } from 'react';
import { initializePaddle } from '@paddle/paddle-js';

const B2BCheckoutView = ({ user }) => {
  const [paddle, setPaddle] = useState(null);

  useEffect(() => {
    initializePaddle({
      environment: process.env.REACT_APP_PADDLE_ENV || 'sandbox',
      token: process.env.REACT_APP_PADDLE_CLIENT_TOKEN || 'test_token',
      eventCallback: function(event) {
        if (event.name === "checkout.completed") {
          console.log("Checkout successfully completed:", event);
          // Wait a brief moment for the webhook to be processed by the backend
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      }
    }).then((paddleInstance) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
      }
    });
  }, []);

  const handleSubscribe = () => {
    if (!paddle) {
      console.warn("Paddle is not initialized yet.");
      return;
    }

    paddle.Checkout.open({
      settings: {
        displayMode: "overlay",
      },
      items: [
        {
          priceId: process.env.REACT_APP_PADDLE_B2B_PRICE_ID || 'pri_01testxxxx',
          quantity: 1,
        },
      ],
      customData: {
        user_id: user?.uid,
        product_type: 'b2b'
      }
    });
  };

  return (
    <div style={{ padding: '20px', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
      <div className="glass-panel" style={{ padding: '40px', maxWidth: '400px', width: '100%', border: '1px solid rgba(79, 70, 229, 0.4)' }}>
        <h2 style={{ marginBottom: '20px', fontSize: '1.8rem', color: 'var(--text-primary)' }}>Desbloquea OnTrack B2B</h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>
          OnTrack Standard - $149/mo
        </p>
        <button 
          className="btn-primary" 
          onClick={handleSubscribe} 
          disabled={!paddle}
          style={{ width: '100%', padding: '12px', fontSize: '1.05rem', fontWeight: 'bold', opacity: !paddle ? 0.7 : 1 }}
        >
          {paddle ? 'Suscribirse ahora' : 'Cargando...'}
        </button>
      </div>
    </div>
  );
};

export default B2BCheckoutView;
